import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { isNullish } from '@/utils/helper'
import TableProfileService from './userTableProfile.service'
import useAction from '@/hooks/useAction'
import { IoEllipseOutline } from 'react-icons/io5'
import { toast } from 'react-toastify'

const useUserTableProfile = () => {
  const service = new TableProfileService()
  const baseCrud = useCrud(API_RESOURCE.USER_TABLE_PROFILE, service)
  const queryClient = useQueryClient()

  const useDeleteTableProfile = () => {
    return useMutation({
      mutationFn: service.deleteTableProfile,
      onSuccess: (res) => {
        console.log('useDeleteTableProfile onSuccess', res)
        if (res?.data?._id) {
          queryClient.invalidateQueries(baseCrud.queryKey.detail(res.data._id))
        }
      },
    })
  }

  const useGetMyTableProfiles = (tableType) => {
    return useQuery({
      queryKey: [...baseCrud.queryKey.lists(), tableType],
      queryFn: () => service.getMyTableProfiles({ tableType }),
      enabled: !isNullish(tableType),
    })
  }

  const useAddAndCreateTableProfile = () => {
    return useMutation({
      mutationFn: service.addAndCreateTableProfile,
      onSuccess: (res) => {
        if (res.message && res.success) {
          toast.success(res.message)
        } else {
          toast.info('Successfully Create Add profile')
        }
      },
    })
  }
  const useToggleShownProfileInSidebar = () => {
    return useMutation({
      mutationFn: service.toggleShownProfileInSidebar,
      onSuccess: (res) => {
        if (res?.data?._id) {
          queryClient.invalidateQueries(baseCrud.queryKey.detail(res.data._id))
        }

        if (res.data.tableType) {
          queryClient.invalidateQueries({ queryKey: [...baseCrud.queryKey.lists(), res.data.tableType] })
        }
      },
    })
  }
  const useMakeDefaultProfile = () => {
    return useMutation({
      mutationFn: service.makeDefaultProfile,
      onSuccess: (res) => {
        if (res?.data?._id) {
          queryClient.invalidateQueries(baseCrud.queryKey.detail(res.data._id))
        }
      },
    })
  }

  return {
    // useFetchAllOffers: baseCrud.useFetchAll,
    // useFetchTableProfile: baseCrud.useFetchOne,
    useUpdateUserTableProfile: baseCrud.useUpdate,
    useDeleteTableProfile: useDeleteTableProfile,
    useGetMyTableProfiles,
    useAddAndCreateTableProfile,
    useToggleShownProfileInSidebar,
    useMakeDefaultProfile,
  }
}

export default useUserTableProfile
